/** Wizard shell: title, stepper, footer, errors. */
const wizShellEN = {
  wizBackToCampaigns: 'Campaigns',
  wizLegacySetup: 'Advanced setup',
  wizOpenWizard: 'Back to guided setup',
  wizTitle: 'New campaign',
  wizStepJob: 'Role',
  wizStepCandidates: 'Candidates',
  wizStepJudging: 'AI rating',
  wizStepList: 'Candidate list',
  wizStepApproach: 'Approach',
  wizStepMessages: 'Messages',
  wizStepReview: 'Review & start',
  wizCancel: 'Cancel',
  wizBack: 'Back',
  wizNext: 'Next',
  wizStart: 'Start campaign',
  wizSaveDraft: 'Save as draft',
  wizLoading: 'Loading …',
  wizSaving: 'Saving …',
  wizSaved: 'Saved',
  wizLoadError: 'The draft could not be loaded.',
  wizSaveError: 'The draft could not be saved.',
  wizNameTaken: 'A campaign with this name already exists.',
  wizNoAccount: 'Connect a LinkedIn account first.',
  wizNewBadge: 'NEW',
  wizBreadcrumbNew: 'New campaign',
  wizNotDraft: 'This campaign has already been started and can no longer be edited here.',
  wizStartFailed: 'The campaign could not be started.',
  wizMissingBriefing: 'Describe the role first.',
  wizMissingName: 'Give the campaign a name.',
  wizMissingAccount: 'Choose a LinkedIn account as sender.',
  wizMissingLocations: 'Add at least one location.',
  wizMissingSearchUrl: 'Paste the link of a LinkedIn search.',
  wizMissingClasses: 'Select at least one class (A or B) to contact.',
  wizMissingCalendarUrl: 'Add the link to your calendar.',
  wizMissingBonus: 'State the amount of the bonus.',
  wizMissingInmailCredit: 'Answer whether the LinkedIn account has InMail credit.',
  wizMissingWorkWindow:
    'The LinkedIn account has no working days and hours set yet. The campaign cannot start without them.',
  wizStartWorkWindowLink: 'Go to account settings',
  wizMissingApproveChoice: 'Choose whether every message is approved beforehand or sent automatically.',
  wizMissingRecontactChoice: 'Choose how already contacted candidates are handled.',
  wizRunningTitle: 'This campaign has already been started and can no longer be changed.',
  wizRunningText:
    'If you want to change something, stop the campaign and create a new one with the new criteria.',
  wizDuplicate: 'Duplicate as new campaign',
  wizDuplicateSuffix: 'copy',
  wizDuplicateError: 'The campaign could not be duplicated.',
  wizSearchRestartTitle: 'Start a new candidate search?',
  wizSearchRestartText:
    'You are changing search criteria of a campaign SAIA has already searched for. This starts a new candidate search: the previous candidates and their ratings are discarded, and the message flow is recalculated.',
  wizSearchRestartConfirm: 'Start new search',
  wizSearchRestartCancel: 'Cancel',
  wizSearchedHint: 'Changing the search criteria starts a new candidate search.',
};
export default wizShellEN;
